export const TOAST_SUMMARY = 'Auth'
